module.exports = __webpack_public_path__ + "static/media/SFMono-SemiboldItalic.2fd68bed.woff2";